import { render, staticRenderFns } from "./VendorDocumentsView.vue?vue&type=template&id=e30625cc"
import script from "./VendorDocumentsView.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorDocumentsView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports